export interface IRestrictedAccessData {
  title: string;
  description: string;
  imageUrl: string;
  alternativeText: string;
}

export const BASIC_RESTRICTED_ACCESS_DATA: IRestrictedAccessData = {
  title: 'Restricted Access',
  description: `<p class="paragraph">You do not have the rights required to access this page.</p>
    <p class="paragraph">Please contact your admin for further information.</p>`,
  imageUrl: '/assets/svg/icon-access-denied.svg',
  alternativeText: 'restricted access',
};

export const NOT_SELECTED_FOR_ASSESSMENT_RESTRICTED_ACCESS_DATA: IRestrictedAccessData = {
  title: 'Restricted Access',
  description: `<p class="paragraph">This counterparty is not selected for assessment.</p>`,
  imageUrl: '/assets/svg/icon-access-denied.svg',
  alternativeText: 'restricted access',
};

export const UNDER_CONSTRUCTION_RESTRICTED_ACCESS_DATA: IRestrictedAccessData = {
  title: 'Under construction',
  description: `<p class="paragraph">We are performing system maintenance.</p>
    <p class="paragraph">During this time, some features may be temporarily unavailable. We appreciate your patience.</p>`,
  imageUrl: '/assets/svg/icon-less-effort.svg',
  alternativeText: 'under construction',
};
